<template>
  <div class="term">
    <div class="plan-condition py-4 border-b border-section_border">
      <h2 class="section-title text-lg text-center">
        {{$t('tour_runrun_title')}}
      </h2>

      <div class="p-4 border-b border-section_border">

        <h3>{{$t('tour_runrun_term1')}}</h3>

        <p>{{$t('tour_runrun_term1_text')}}</p>

        

        <h3>{{$t('tour_runrun_term2')}}</h3>

        <p>{{$t('tour_runrun_term2_text')}}</p>

        <p>{{$t('tour_runrun_term2_text2')}}</p>

        <p>{{$t('tour_runrun_term2_text3')}}</p>

        

        <h3>{{$t('tour_runrun_term3')}}</h3>

        <p>{{$t('tour_runrun_term3_text')}}</p>

        <p>{{$t('tour_runrun_term3_text2')}}</p>

        <p>{{$t('tour_runrun_term3_text3')}}</p>

        

        <h3>{{$t('tour_runrun_term4')}}</h3>

        <p>{{$t('tour_runrun_term4_text')}}</p>

        

        <h3>{{$t('tour_runrun_term5')}}</h3>

        <p>{{$t('tour_runrun_term5_text')}}</p>

        <p>{{$t('tour_runrun_term5_text2')}}</p>

        <p>{{$t('tour_runrun_term5_text3')}}</p>

        <p>{{$t('tour_runrun_term5_text4')}}</p>

        <p>{{$t('tour_runrun_term5_text5')}}</p>

        <p>{{$t('tour_runrun_term5_text6')}}</p>

        <p>{{$t('tour_runrun_term5_text7')}}</p>

        <p>{{$t('tour_runrun_term5_text8')}}</p>

        

        <h3>{{$t('tour_runrun_term6')}}</h3>

        <p>{{$t('tour_runrun_term6_text')}}</p>

        <p>{{$t('tour_runrun_term6_text2')}}</p>

        <p>{{$t('tour_runrun_term6_text3')}}</p>

        <p>{{$t('tour_runrun_term6_text4')}}</p>

        <p>{{$t('tour_runrun_term6_text5')}}</p>

        <p>{{$t('tour_runrun_term6_text6')}}</p>

        <p>{{$t('tour_runrun_term6_text7')}}</p>

        <p>{{$t('tour_runrun_term6_text8')}}</p>

        <p>{{$t('tour_runrun_term6_text9')}}</p>

        

        <h3>{{$t('tour_runrun_term7')}}</h3>

        <p>{{$t('tour_runrun_term7_text')}}</p>

        <p>{{$t('tour_runrun_term7_text2')}}</p>

        <p>{{$t('tour_runrun_term7_text3')}}</p>

        

        <h3>{{$t('tour_runrun_term8')}}</h3>

        <p>{{$t('tour_runrun_term8_text')}}</p>

        <p>{{$t('tour_runrun_term8_text2')}}</p>

        <p>{{$t('tour_runrun_term8_text3')}}</p>

        <p>{{$t('tour_runrun_term8_text4')}}</p>

        <p>{{$t('tour_runrun_term8_text5')}}</p>

        <p>{{$t('tour_runrun_term8_text6')}}</p>

        <p>{{$t('tour_runrun_term8_text7')}}</p>

        <p>{{$t('tour_runrun_term8_text8')}}</p>

        <p>{{$t('tour_runrun_term8_text9')}}</p>

        

        <h3>{{$t('tour_runrun_term9')}}</h3>

        <p>{{$t('tour_runrun_term9_text')}}</p>

        <p>{{$t('tour_runrun_term9_text2')}}</p>

        

        <h3>{{$t('tour_runrun_term10')}}</h3>

        <p>{{$t('tour_runrun_term10_text')}}</p>

        <p>{{$t('tour_runrun_term10_text2')}}</p>

        

        <h3>{{$t('tour_runrun_term11')}}</h3>

        <p>{{$t('tour_runrun_term11_text')}}</p>

        <p>{{$t('tour_runrun_term11_text2')}}</p>

        <p>{{$t('tour_runrun_term11_text3')}}</p>

        <p>{{$t('tour_runrun_term11_text4')}}</p>

        <p>{{$t('tour_runrun_term11_text5')}}</p>

        <p>{{$t('tour_runrun_term11_text6')}}</p>

        <p>{{$t('tour_runrun_term11_text7')}}</p>

        <p>{{$t('tour_runrun_term11_text8')}}</p>

        <p>{{$t('tour_runrun_term11_text9')}}</p>

        <p>{{$t('tour_runrun_term11_text10')}}</p>

        <p>{{$t('tour_runrun_term11_text11')}}</p>

        <p>{{$t('tour_runrun_term11_text12')}}</p>

        <p>{{$t('tour_runrun_term11_text13')}}</p>

        <p>{{$t('tour_runrun_term11_text14')}}</p>

        <p></p>

        <p>{{$t('tour_runrun_term11_text15')}}</p>

        <p>{{$t('tour_runrun_term11_text16')}}</p>

        

        <h3>{{$t('tour_runrun_term12')}}</h3>

        <p>{{$t('tour_runrun_term12_text')}}</p>

        

        <h3>{{$t('tour_runrun_term13')}}</h3>

        <p>{{$t('tour_runrun_term13_text')}}</p>

        

        <h3>{{$t('tour_runrun_term14')}}</h3>

        <p>{{$t('tour_runrun_term14_text')}}</p>

        <p>{{$t('tour_runrun_term14_text2')}}</p>

        <p>{{$t('tour_runrun_term14_text3')}}</p>

        <p>{{$t('tour_runrun_term14_text4')}}</p>

        

        <h3>{{$t('tour_runrun_term15')}}</h3>

        <p>{{$t('tour_runrun_term15_text')}}</p>


        <h3>{{$t('tour_runrun_term16')}}</h3>

        <p>{{$t('tour_runrun_term16_text')}}</p>

        

        <h3>{{$t('tour_runrun_term17')}}</h3>

        <p>{{$t('tour_runrun_term17_text')}}</p>

        

        <h3>{{$t('tour_by_law')}}</h3>

        <p>{{$t('tour_runrun_by_law_text')}}</p>

        

        <p>{{$t('tour_above')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../constants";

export default {
  methods: {
    back: function () {
        this.$router.push({ path: '/plans' })
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>